import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data : {
        products:[],
        selectedProducts:{},
        agreements : {},
        availability:{}
    } ,
    filters : {

    }
}
export const calendarSlice = createSlice({
  name: "calendar",
  initialState: initialState,
  reducers: {
    setRangeAvailability:(state,action)=>{
      if(!state.data.availability[action.payload.month]) {
        state.data.availability[action.payload.month] = {}
      }
      state.data.availability[action.payload.month][action.payload.pId]=action.payload.data
    },
    setCalendarFilters : (state,action)=>{
      state.filters[action.payload.key] = action.payload.value
    } ,
    setFilteredProducts:(state , action)=>{
      state.data.idData = {}
      const idToData = {}
      for (var product of action.payload){
        idToData[product.id] = {name:product.name,type:product.type,units:product.totalUnits}
      }
      state.data.idData = idToData
      state.data.products = action.payload
    } ,
    setSelectedProduct:(state,action)=>{
      if(action.payload.fromUrl){
        state.data.idData = {[action.payload.id]:{name:action.payload.name,type:action.payload.type,units:action.payload.totalUnits}}
        state.data.products = [{id:action.payload.id,name:action.payload.name,type:action.payload.type,totalUnits:action.payload.totalUnits}]
        state.data.selectedProducts[action.payload.id] = action.payload.name
        return
      }

      if (action.payload.id in state.data.selectedProducts){
        delete state.data.selectedProducts[action.payload.id]
      } else {
      state.data.selectedProducts[action.payload.id] = action.payload.name
      }
    }  ,
    setRangeAgreements : (state,action)=>{
      if (!(action.payload.month in state.data.agreements)){
        state.data.agreements[action.payload.month]={}
      }
      if (!(action.payload.rentId in state.data.agreements[action.payload.month])){
        state.data.agreements[action.payload.month][action.payload.rentId] = action.payload.agreements
      }


    },
    clearCalendarData:(state,action)=>{
      state.data = initialState.data
    }
  }})

export const {setRangeAvailability,clearCalendarData,setCalendarFilters,setFilteredProducts,setSelectedProduct,setRangeAgreements} = calendarSlice.actions
export default calendarSlice.reducer
